import styled from "styled-components";
import { device } from "../../util/responsive-util";

export const Tabella = styled.div`
    width: 70%;
    float:right;

    h4 span {
        font-weight: normal;
        font-size: 0.9em;
    }
      
    @media ${device.tablet} {
        width: 100%;
        float: none;
    }
`